export default function Merits() {
  const merits = [
    {
      icon: 'ri-percent-line',
      title: 'どこで使っても1%の高還元率',
      description: '大手ECモール系カードは通常利用でも100円につき1ポイント（還元率1%）が貯まります。コンビニ、スーパー、ガソリンスタンド、公共料金の支払いなど、どこで使っても高還元率。年会費無料のカードの中では最高クラスの還元率を誇ります。貯まったポイントはECモールやスマホ決済で1ポイント=1円として使えるので、実質的な値引きと同じです。',
      highlight: '年会費無料カードで1%還元は業界トップクラス！',
    },
    {
      icon: 'ri-shopping-bag-line',
      title: 'ECモールで最大3倍のポイント還元',
      description: 'ECモールでの買い物なら、いつでもポイント3倍（還元率3%）。さらにモバイルサービスや銀行などの関連サービスを併用すると、SPU（スーパーポイントアッププログラム）で最大16倍までポイント倍率がアップ。経済圏を活用すれば、年間数万円分のポイントを貯めることも可能です。お買い物マラソンやスーパーセールと組み合わせれば、さらにお得に。',
      highlight: '経済圏の活用で年間10万ポイント以上も夢じゃない！',
    },
    {
      icon: 'ri-gift-line',
      title: '新規入会で5,000ポイントプレゼント',
      description: '新規入会＋利用で5,000円相当のポイントがもらえます。入会特典はカード到着後に会員サイトで受け取り申請をするだけ。さらに初回利用で追加ポイントがもらえるキャンペーンも頻繁に開催されています。年会費無料なのに入会特典が充実しているのは、大手ECモール系カードならではの魅力です。',
      highlight: '※キャンペーン内容は時期により変動します',
    },
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-[#F8F9FA] to-[#FFF0F0]">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#BF0000] mb-3 text-center">
          大手ECモール系カードの3つのメリット
        </h2>
        <p className="text-gray-600 text-center mb-12">なぜ日本一選ばれているのか？その理由を徹底解説</p>

        <div className="space-y-6">
          {merits.map((merit, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-6 md:p-8 hover:shadow-xl transition-shadow">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-[#BF0000] to-[#FF6B6B] rounded-full flex-shrink-0">
                  <i className={`${merit.icon} text-white text-xl`}></i>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="bg-[#BF0000] text-white text-xs font-bold px-3 py-1 rounded-full">
                      メリット{index + 1}
                    </span>
                    <h3 className="text-lg md:text-xl font-bold text-[#BF0000]">{merit.title}</h3>
                  </div>
                  <p className="text-gray-700 text-sm md:text-base leading-relaxed mb-3">
                    {merit.description}
                  </p>
                  <div className="bg-[#FFF8E1] border-l-4 border-[#FF9900] px-4 py-2 rounded">
                    <p className="text-[#BF0000] text-xs md:text-sm font-medium">
                      <i className="ri-information-line mr-1"></i>
                      {merit.highlight}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
